import { EngagementErrorDialogDataModel } from './engagement-error-dialog-data.model';

export class EngagementConsentRequiredStrategyModel implements EngagementErrorDialogDataModel {
  engagementId: number;
  
  constructor(engagementId: number) {
    this.engagementId = engagementId;
  }

  getTitle = () => 'This document requires you to mark the consent field before continuing.';
  getMessage = () => 'Please fill in consent before proceeding with the document\'s completion.';
  getButtonText = () => 'Understood';
  getRoutePath = () => null;
}